import { FC, useEffect, useState } from "react";
import { ProgressBarProps } from "./types";
import { Row } from "../containers";
import { useProgressStore, useThemeStore } from "../../stores";

const ProgressBar: FC<ProgressBarProps> = ({
  filename = "",
  background,
  className,
  foreground,
  props,
  style,
}) => {
  const theme = useThemeStore((s) => s.theme);

  const [percent, setPercent] = useState<number>(0);

  useEffect(() => {
    if (!filename) return;
    let interval = setInterval(() => {
      setPercent(
        useProgressStore.getState().getProgress(filename)?.percent || 0
      );
    }, 1000);
    return () => {
      clearInterval(interval);
      useProgressStore.getState().rmProgress(filename);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filename]);

  if (!filename) return <></>;
  return (
    <Row
      style={{
        width: "100%",
        height: 10,
        borderRadius: 15,
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
      background={background || theme.background}
      className={className}
      props={props}
    >
      <Row
        background={foreground || theme.primary}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: `${percent}%`,
          height: "inherit",
          borderRadius: 15,
        }}
        className="transition"
      ></Row>
    </Row>
  );
};

export default ProgressBar;
